import axios from "axios";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { GlobalContext } from "../../context/GlobalState";
import ReportsTable from "./ReportsTable";
import DatePicker from "react-datepicker";
import { FilterList } from "@material-ui/icons";

const Report = () => {
  const [loader, setLoader] = useState(false);
  const { userDetails } = useContext(GlobalContext);
  const [tableData, setTableData] = useState([]);
  const [filterData, setFilterData] = useState({});
  const [filtered, setFiltered] = useState([]);

  function filterVisitorData(_, filterQuery) {
    const query = filterQuery || filterData;
    const filter = tableData.filter((row) => {
      // 1. Date filters (based on createdAt)
      if (query.fromDate) {
        const from = new Date(query.fromDate);
        if (new Date(row.createdAt) < from) return false;
      }

      if (query.toDate) {
        const to = new Date(query.toDate);
        if (new Date(row.createdAt) > to) return false;
      }

      // 2. Class filter - match any section
      if (query.class) {
        const target = query.class.toLowerCase();
        const hasMatchingClass = row.sections?.some((section) => {
          const sectionStr =
            `${section.grade}-${section.section}`.toLowerCase();
          return sectionStr === target;
        });
        if (!hasMatchingClass) return false;
      }

      // 3. Subject name filter
      if (
        query.subject &&
        row.subjectId?.name?.toLowerCase() !== query.subject.toLowerCase()
      ) {
        return false;
      }

      // 4. Teacher (creator) name filter
      if (
        query.teacherName &&
        (!row.creatorId?.name ||
          !row.creatorId.name
            .toLowerCase()
            .includes(query.teacherName.toLowerCase()))
      ) {
        return false;
      }

      return true;
    });

    setFiltered([...filter]);
  }

  const filterObjects = useMemo(() => {
    const obj = { teachers: new Set(), grades: new Set(), subjects: new Set() };
    tableData.forEach((row) => {
      if (row.creatorId?.name && !obj.teachers.has(row.creatorId?.name || ""))
        obj.teachers.add(row.creatorId?.name || "");

      if (row.sections) {
        row.sections.forEach((section) => {
          const name = `${section?.grade || ""}-${section?.section || ""}`;
          if (!obj.grades.has(name)) obj.grades.add(name);
        });
      }

      if (!obj.subjects.has(row.subjectId?.name || ""))
        obj.subjects.add(row.subjectId?.name || "");
    });

    return {
      teachers: [...obj.teachers].sort(),
      grades: [...obj.grades].sort(),
      subjects: [...obj.subjects].sort(),
    };
  }, [tableData]);

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      const authToken = localStorage.getItem("authToken");
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${userDetails.userId}/assigntests`,
          {
            headers: {
              token: authToken,
            },
          }
        );
        if (response.data.status === "success") {
          const tests = response.data.data.assignTests;
          setTableData(tests);
          setFiltered(tests);
          setLoader(false);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);
  return (
    <div className="my-5" style={{ width: "98%", margin: "auto" }}>
      <div
        className="table_title_section"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <h2
          style={{
            fontWeight: 700,
            whiteSpace: "nowrap",
            marginLeft: "0.5%",
            marginTop: "0.5%",
          }}
        >
          Tests
        </h2>
        <div style={{ margin: "auto 0" }}>
          <span
            className="fw-bold"
            style={{ cursor: "pointer" }}
            data-bs-toggle="modal"
            data-bs-target="#filterAnalyticsModal"
          >
            <FilterList /> Filter
          </span>
        </div>
      </div>
      {!loader ? (
        <ReportsTable rows={filtered} />
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            position: "absolute",
            left: "50%",
            top: "50%",
          }}
        >
          <div className="spinner">
            Loading
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
          </div>
        </div>
      )}

      {/* filter Modal */}
      <div
        className="modal fade filterAnalyticsModal mt-5"
        id="filterAnalyticsModal"
        tabIndex="-1"
        aria-labelledby="filterAnalyticsModalLabel"
        data-bs-backdrop="static"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="filterAnalyticsModalLabel">
                FILTERS
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form action="#">
                <div className="row mb-3">
                  <div className="col-sm mb-3">
                    <label htmlFor="filterFromDate input">From</label>
                    <DatePicker
                      selected={filterData.fromDate}
                      dateFormat="dd/MM/yyyy"
                      id="filterFromDate"
                      onChange={(date) => {
                        setFilterData({
                          ...filterData,
                          fromDate: date,
                        });
                      }}
                      placeholderText="From Date"
                      className="form-control"
                    />
                  </div>
                  <div className="col-sm">
                    <label htmlFor="filterToDate">To</label>
                    <DatePicker
                      selected={filterData.toDate}
                      dateFormat="dd/MM/yyyy"
                      id="filterToDate"
                      onChange={(date) => {
                        setFilterData({
                          ...filterData,
                          toDate: date,
                        });
                      }}
                      placeholderText="To Date"
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-sm mb-3">
                    <label htmlFor="filter_class_input">Class</label>
                    <br></br>
                    <select
                      name="filter_class_input"
                      id="filter_class_input"
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          class: e.target.value,
                        });
                      }}
                      value={filterData.class ? filterData.class : ""}
                      className="form-select"
                    >
                      <option value={""}>select</option>
                      {filterObjects.grades.map((c) => (
                        <option value={c}>{c}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm mb-3">
                    <label htmlFor="filter_subject_input">Subject</label>
                    <br></br>
                    <select
                      name="filter_subject_input"
                      id="filter_subject_input"
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          subject: e.target.value,
                        })
                      }
                      className="form-select"
                      value={filterData.subject ? filterData.subject : ""}
                    >
                      <option value={""}>select</option>
                      {filterObjects.subjects.map((c) => (
                        <option value={c}>{c}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row mb-3">
                  {userDetails?.role === "teacher" ? null : (
                    <div className="col-sm mb-3">
                      <label htmlFor="filter_class_input">Teachers</label>
                      <br></br>
                      <select
                        name="filter_class_input"
                        id="filter_class_input"
                        onChange={(e) => {
                          setFilterData({
                            ...filterData,
                            teacherName: e.target.value,
                          });
                        }}
                        value={
                          filterData.teacherName ? filterData.teacherName : ""
                        }
                        className="form-select"
                      >
                        <option value={""}>select</option>
                        {filterObjects.teachers.map((c) => (
                          <option value={c}>{c}</option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
              </form>
            </div>

            <div className="mb-3 p-2">
              <div className="row">
                <div className="col d-grid">
                  <button
                    type="button"
                    className="btn filterAnalyticsModalBtnCancel"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      const filter = {
                        fromDate: null,
                        toDate: null,
                        class: null,
                        subject: null,
                        teacherName: null,
                      };
                      setFilterData(filter);
                      filterVisitorData(undefined, filter);
                    }}
                  >
                    Clear
                  </button>
                </div>
                <div className="col d-grid">
                  <button
                    type="button"
                    className="btn  filterAnalyticsModalBtnApply"
                    onClick={filterVisitorData}
                    data-bs-dismiss="modal"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Report;
